import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCar, faRightLeft, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles/pwa/BottomNav.module.scss';
import useStandalone from './useStandalone';

// Patru tab-uri, nu cinci. Pe 360px lățime, cinci etichete în română ajung la
// ~62px fiecare și se înghesuie; „Cererile mele" rămâne la un tap distanță din
// ecranul principal, unde oricum are nevoie de context, nu de acces instant.
const TABS_LOGGED_IN = [
  { label: 'Acasă', link: '/', icon: faHome },
  { label: 'RCA', link: '/user/asigurari/rca', icon: faCar },
  { label: 'Valutar', link: '/valutar', icon: faRightLeft },
  { label: 'Cont', link: '/user/profil/info', icon: faUserCircle },
];

const TABS_LOGGED_OUT = [
  { label: 'Acasă', link: '/', icon: faHome },
  { label: 'RCA', link: '/asigurari-rca', icon: faCar },
  { label: 'Valutar', link: '/valutar', icon: faRightLeft },
  { label: 'Cont', link: '/login', icon: faUserCircle },
];

const isActive = (pathname, link) =>
  link === '/' ? pathname === '/' : pathname === link || pathname.startsWith(link + '/');

const BottomNav = () => {
  const standalone = useStandalone();
  const router = useRouter();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  // Bara apare DOAR în app-ul instalat (senzație nativă), nu în browser.
  if (!standalone) return null;

  const tabs = isLoggedIn ? TABS_LOGGED_IN : TABS_LOGGED_OUT;

  return (
    <nav className={styles.root} aria-label="Navigație principală">
      {tabs.map((tab) => {
        const active = isActive(router.pathname, tab.link);
        return (
          <Link
            key={tab.link}
            href={tab.link}
            className={`${styles.tab} ${active ? styles.active : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <FontAwesomeIcon icon={tab.icon} height="20" width="20" />
            <span className={styles.label}>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNav;
